module.exports = __webpack_public_path__ + "img/w21.67ffb93e.svg";